import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Derive display name from lead/client object
 * Supports both new (firstName/lastName) and legacy (name) fields
 * 
 * @param {Object} entity - Lead or client object
 * @param {string} fallback - Fallback text if no name available
 * @returns {string} Display name
 */
export function getDisplayName(entity, fallback = 'Unnamed') {
  if (!entity) return fallback;
  
  // Try firstName + lastName first (new format)
  const firstName = entity.firstName?.trim() || '';
  const lastName = entity.lastName?.trim() || '';
  
  if (firstName || lastName) {
    return [firstName, lastName].filter(Boolean).join(' ');
  }
  
  // Fall back to legacy name field
  if (entity.name?.trim()) {
    return entity.name.trim();
  }
  
  // Try companyName as last resort
  if (entity.companyName?.trim()) {
    return entity.companyName.trim();
  }
  
  return fallback;
}
